<template>
  <FullPageLayout class="game-container">
    <template v-if="fetchState.pending">
      <div>loading...</div>
    </template>
    <template v-else-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>
    <template v-else>
      <GameTitle />
      <StartGame />
      <AdController unit="masthead" />
      <Description />
      <Badges :game-id="game.id" />
      <AdController unit="oyunlarInpage1" class="sm:mb-9 sm:mt-4" />
      <AdController unit="OyunlarInpageMobile2" class="mt-3 mb-8" />
      <Favorites />
      <SuggestedGames v-if="IS_ONEDIO" />
    </template>
  </FullPageLayout>
</template>

<script>
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import { defineComponent, useRoute, useFetch, useContext } from '@nuxtjs/composition-api';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import { initializeAdLoaders } from '@/modules/ads/adUtils';
import AdController from '@/modules/ads/components/AdController';
import GameHeader from '~/modules/oyun/components/GameHeader.vue';
import GameCardList from '~/modules/oyun/components/GameCardList.vue';
import GameCard from '~/modules/oyun/components/GameCard.vue';
import GameBar from '~/modules/oyun/components/GameBar.vue';
import Description from '~/modules/oyun/components/Description.vue';
import Favorites from '~/modules/oyun/components/Favorites.vue';
import StartGame from '~/modules/oyun/components/StartGame.vue';
import SuggestedGames from '~/modules/oyun/components/SuggestedGames.vue';
import GameTitle from '~/modules/oyun/components/GameTitle.vue';
import GameModal from '~/modules/oyun/components/GameModal.vue';
import { useGameMeta } from '~/modules/oyun/utils/gameMeta';
import gameData from '~/modules/oyun/gameData';
import { IS_ONEDIO } from '~/constants/config';
import Badges from '~/modules/oyun/components/Badges.vue';

export default defineComponent({
  components: {
    FullPageLayout,
    ErrorPageLayout,
    GameHeader,
    GameCardList,
    GameCard,
    GameBar,
    Favorites,
    StartGame,
    SuggestedGames,
    GameTitle,
    GameModal,
    Description,
    Badges,
    AdController,
  },

  head: {
    bodyAttrs: {
      class: 'bg-[#f7f8fb] o-ps-global',
    },
  },
  setup() {
    const route = useRoute();
    const { $error } = useContext();

    const slug = route.value.params.slug;
    const game = gameData.filter((g) => {
      return g.slug === slug;
    })[0];
    useGameMeta({ game });
    const { generateAdConfig } = initializeAdLoaders();
    const serversideAdConfig = generateAdConfig('Games');
    const { fetchState } = useFetch(() => {
      serversideAdConfig();
      if ((slug !== 'skor' && slug !== 'leaderboard' && !game) || game === 'emojile' || game === 'bilpop')
        $error('Page not found', 404, false);
    });

    return { fetchState, IS_ONEDIO, game };
  },
});
</script>
